import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "word", "panel"]
  static values = {
    interval: { type: Number, default: 2600 }
  }

  connect() {
    this.index = 0
    this.applyState()

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || this.wordTargets.length < 2) {
      return
    }

    this.timer = window.setInterval(() => {
      this.index = (this.index + 1) % this.wordTargets.length
      this.applyState()
    }, this.intervalValue)
  }

  disconnect() {
    if (this.timer) {
      window.clearInterval(this.timer)
    }
  }

  applyState() {
    if (this.hasTrackTarget) {
      this.trackTarget.style.transform = `translateY(calc(-1em * ${this.index}))`
    }

    this.panelTargets.forEach((panel, idx) => {
      const active = idx === this.index
      panel.classList.toggle("opacity-100", active)
      panel.classList.toggle("translate-y-0", active)
      panel.classList.toggle("scale-100", active)
      panel.classList.toggle("opacity-0", !active)
      panel.classList.toggle("translate-y-2", !active)
      panel.classList.toggle("scale-[0.98]", !active)
      panel.classList.toggle("pointer-events-none", !active)
      panel.setAttribute("aria-hidden", active ? "false" : "true")
    })
  }
}
